export const queryKeys = {
  LINE_CHANNEL_ACCOUNTS: 'line_channel_accounts',
  LINE_CHANNEL_DETAIL: 'line_channel_detail',
  LINE_CHANNEL_BAN_STATUS: 'line_channel_ban_status',
  LINE_CHANNEL_BAN_STATUS_CHANNELS: 'line_channel_ban_status_channels',
  LINE_FRIENDS: 'line_friends',
  LINE_FRIEND_DETAIL: 'line_friend_detail',
  ADMIN_ACCOUNTS: 'admin_accounts',
  ADMIN_ACCOUNT_DETAIL: 'admin_account_detail',
  ORGANIZATIONS: 'organizations',
  DELIVERY_COUNT: 'delivery_count',
  TEST_DELIVERY_COUNT: 'test_delivery_count',
  RICH_MENU_TEMPLATES: 'rich_menu_templates',
  RICH_MENU_CURRENT: 'rich_menu_current',
  MESSAGE_TEMPLATES: 'message_templates',
  AUTO_REPLY_SETTINGS: 'auto_reply_settings',
  AUTO_REPLY_KEYWORD_RULES: 'auto_reply_keyword_rules',
  AUTO_REPLY_MESSAGE_ASSETS: 'auto_reply_message_assets',
  RICH_MESSAGE_TEMPLATES: 'rich_message_templates',
  OA_CREATION_JOBS: 'oa_creation_jobs',
  OA_CREATION_JOB_DETAIL: 'oa_creation_job_detail',
  TAGS: 'tags',
  SURVEYS: 'surveys',
  SUMMARY: 'summary',
  FRIEND_ANALYTICS: 'friend_analytics',
  FRIEND_ANALYTICS_COLLECT: 'friend_analytics_collect',
  SEND_HISTORY: 'send-history',
  AD_CODES: 'adCodes',
  TERMS_POLICY: 'terms_policy',
  TERMS_VERSIONS: 'terms_versions',
  TERMS_VERSION_DETAIL: 'terms_version_detail',
  TERMS_MEMBER_STATUSES: 'terms_member_statuses',
  ACCOUNT_TERMS: 'account_terms',
} as const;
